import { createAction } from '@reduxjs/toolkit'
import { QuoteResponseType } from 'hooks/swap/useLiquidityProvider'

export const setLiquidityProvider =
  createAction<{ liquidityProvider: QuoteResponseType | undefined }>('liquidityProvider')
